import { httpRequest } from '@/apis/request'

enum Apis {
  getHighlightPlankProcess = 'highlight_plank_process',
}

export async function fetchHighlightPlankProcess() {
  return httpRequest.get(Apis.getHighlightPlankProcess)
}
